import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class FrequentlyQuestionService {
  static ENDPOINT = `${BASE}/frequentlyQuestion`;

  static async creates(frequentlyQuestionCreates) {
    return await request({
      url: `${this.ENDPOINT}/`,
      method: 'POST',
      body: frequentlyQuestionCreates
    })
  }

  static async getAll() {
    return await request({
      url: `${this.ENDPOINT}/`,
      headers: {'Accept': 'application/json'}
    })
  }

  static async updates(frequentlyQuestionUpdates) {
    return await request({
      url: `${this.ENDPOINT}/`,
      method: 'PUT',
      body: frequentlyQuestionUpdates
    })
  }

  static async delete(id) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      method: 'DELETE',
      headers: {'Accept': 'application/json'}
    })
  }
}

export default FrequentlyQuestionService;
